import { capitalizeOnlyFirstLetter } from '@/util-conversion/misc';

interface VehicleSubDetailsProps {
  className?: string;
  trim?: string;
  odometer?: number;
  color?: string;
}

export default function VehicleSubDetails({
  className = 'body2',
  trim,
  odometer,
  color,
}: VehicleSubDetailsProps) {
  return (
    <p className={className}>
      {trim ? `${trim}・` : ''}
      {odometer
        ? `${odometer.toLocaleString('en-US', { maximumFractionDigits: 0 })} miles${color ? '・' : ''}`
        : ''}
      {color ? capitalizeOnlyFirstLetter(color) : ''}
    </p>
  );
}
